import React, { memo } from 'react';

import PropTypes from 'prop-types';

import localization from '../../../../shared/strings';
import Options from '../../Options/Options';

const l10n = localization.PRODUCT_INFO;

const AggregatedOptionsSection = ({
  readOnly,
  readOnlyTooltip,
  detailsPanelVisibility,
  toggleVisibility,
  blockName,
  blockTitle,
}) => (
  <Options
    readOnly
    showDisabledManagementActions={readOnly}
    disabledManagementTooltip={readOnlyTooltip || l10n.optionsManageOnMasterTooltip}
    detailsPanelVisibility={detailsPanelVisibility}
    toggleVisibility={toggleVisibility}
    blockName={blockName}
    blockTitle={blockTitle || l10n.variantStructure}
    currentValue={[]}
  />
);

AggregatedOptionsSection.propTypes = {
  readOnly: PropTypes.bool,
  readOnlyTooltip: PropTypes.string,
  detailsPanelVisibility: PropTypes.objectOf(PropTypes.bool).isRequired,
  toggleVisibility: PropTypes.func.isRequired,
  blockName: PropTypes.string.isRequired,
  blockTitle: PropTypes.node,
};

AggregatedOptionsSection.defaultProps = {
  readOnly: false,
  readOnlyTooltip: null,
  blockTitle: null,
};

export default memo(AggregatedOptionsSection);
